import React, { useEffect, useState } from "react";
import { useDisplayView } from "./hooks/useDisplayView";
import { useViewHotkeys } from "./hooks/useViewHotkeys";

import { Navbar } from "./components/Navbar";
import { HeaderTread } from "./components/HeaderTread";
import { HeroBanner } from "./components/HeroBanner";
import { Podium } from "./components/podium/Podium";
import { StandingsTable } from "./components/StandingsTable";
import { FooterTread } from "./components/FooterTread";
import { Diagram } from "./components/diagram/Diagram";
import { CreateBusinessPartner } from "./components/businessPartner/CreateBusinessPartner";
import { ConfettiLayer } from "./components/effects/ConfettiLayer";

function App() {
  const { view, go } = useDisplayView();
  useViewHotkeys(go);

  // 🔹 Estados
  const [config, setConfig] = useState(null);
  const [raceData, setRaceData] = useState([]); 
  const [loadingRaces, setLoadingRaces] = useState(false);

  const fetchConfig = async () => {
    try {
      const res = await fetch("https://middleware-lite.hitch.cl/api/settings");
      const data = await res.json();

      // Normalizar unlockAt
      if (data.unlockAt) {
        data.unlockAt = new Date(data.unlockAt.replace(" ", "T"));
      } else {
        data.unlockAt = null;
      }

      setConfig(data);
    } catch (err) {
      console.error("Error al obtener configuración:", err);
    }
  };

  const fetchRaces = async () => {
    setLoadingRaces(true);
    try {
      const res = await fetch("https://middleware-lite.hitch.cl/api/races/all");
      const data = await res.json();

      // Normalizamos formato de carreras
      const normalized = data.map((d) => ({
        name: d.name,
        team: d.company || "N/A",
        last: d.laps?.length ? d.laps[d.laps.length - 1].lap_time : "-",
        best: d.best_lap || "-",
        total: d.total_race_time || "-",
        ...d,
      }));

      setRaceData(normalized);
    } catch (err) {
      console.error("Error al obtener carreras:", err);
    } finally {
      setLoadingRaces(false);
    }
  };

  // Primer load
  useEffect(() => {
    fetchConfig();
    fetchRaces();
  }, [view]);

  // 🔄 Auto refresh cada 30s si la sesión NO está finalizada
  useEffect(() => {
    if (!config?.finishSession) {
      const interval = setInterval(() => {
        fetchRaces();
      }, 30000); // 30 segundos
      return () => clearInterval(interval);
    }
  }, [config?.finishSession]);

  return (
    <div className="min-h-screen bg-black text-white">
      <HeaderTread />
      <Navbar view={view} go={go} />

      <main className="p-3">
        <div id="hero" className={`${view === "all" || view === "hero" ? "" : "hidden"} ${view === "hero" ? " flex items-center" : ""}`}>
          <HeroBanner view={view} go={go} />
        </div>

        <div id="podium" className={`${view === "podium" ? "" : "hidden"} ${view === "podium" ? " flex items-center" : ""}`}>
          {config?.finishSession && <ConfettiLayer continuous pieces={220} />}
          <Podium
            id="podium"
            unlockAt={config?.unlockAt}
            fetchTop3={async () => raceData.slice(0, 3)}
            top3={raceData.slice(0, 3)}
            view={view}
            finishSession={config?.finishSession}
          />
        </div>

        <div id="standings" className={`${view === "standings" ? "" : "hidden"} ${view === "standings" ? " flex items-center" : ""}`}>
          {config?.finishSession && <ConfettiLayer continuous pieces={220} />}
          <StandingsTable
            data={raceData}
            view={view}
            finishSession={config?.finishSession}
            loading={loadingRaces}
          />
        </div>

        <div id="diagram" className={`${view === "diagram" ? "" : "hidden"} ${view === "diagram" ? " flex items-center" : ""}`}>
          <Diagram
            view={view}
            image={config?.diagramImage == null ? "/diagram.png" : config?.diagramImage}
          />
        </div>

        <div id="login" className={`${view === "login" ? "" : "hidden"} ${view === "login" ? " flex items-center" : ""}`}>
          <CreateBusinessPartner view={view} />
        </div>
      </main>
      <FooterTread />
    </div>
  );
}

export default App;
